import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      locale: state => state.locale,
      reverseTextForLocals: state => state.filters.reverseTextForLocals,
    }),
    reverseText() {
      return this.locale && this.reverseTextForLocals.includes(this.locale) ? 'revers-text' : '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/filters/revers-text.js